class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
          element.closest('.product-media-modal__content-wrap').classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.closest('.product-media-modal__content-wrap').classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  class ProductMeta extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.product-meta__toggle');
      this.main = this.querySelector('.product-meta__main');
      this.table = this.querySelector('.product-meta__table');
      this.open = true;

      if (this.toggle) this.toggle.addEventListener('click', this.handleToggle.bind(this));
    }

    handleToggle(e) {
      this.open ? this.handleClose() : this.handleOpen();
    }

    handleOpen() {
      this.main.classList.remove('open');
      this.table.classList.add('open');
      this.open = true;
      this.toggle.innerHTML = '&ndash; Show less'
    }

    handleClose() {
      this.main.classList.add('open');
      this.table.classList.remove('open');
      this.open = false;
      this.toggle.innerHTML = '&plus; View all'
    }


  };
  customElements.define('product-meta', ProductMeta);


  class InquireFormModal extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('.inquire-close');
      this.modalBg = this.querySelector('.modal-bg');
      this.lastFocused = null;

      this._handleOpen = this._onOpen.bind(this);
      this._handleClose = this._onClose.bind(this);
      this._handleKeyUp = this._onKeyUp.bind(this);

      this.closeButton.addEventListener('click', this._handleClose);
      this.modalBg.addEventListener('click', this._handleClose);
      document.addEventListener('keyup', this._handleKeyUp);

      document.querySelectorAll('.inquire-product-toggle').forEach((btn) => {
        btn.addEventListener('click', this._handleOpen);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this._handleKeyUp);
    }

    _onOpen(e) {
      e.preventDefault();
      this.lastFocused = e.currentTarget;
      this.classList.add('open');
      this.removeAttribute('inert');
      this.removeAttribute('aria-hidden');
      document.body.classList.add('modal-open');
      trapFocus(this, this.closeButton);
    }

    _onClose(e) {
      e.preventDefault();
      this.classList.remove('open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      removeTrapFocus(this.lastFocused);
    }

    _onKeyUp(e) {
      if (e.key === 'Escape' && this.classList.contains('open')) {
        this._onClose(e);
      }
    }
  }
  customElements.define('inquire-form-modal', InquireFormModal);